"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeCHex = exports.decodeHex = exports.hasHexPrefix = exports.isHex = exports.encodeCHex = exports.decodeCB58 = exports.isBase58 = exports.encodeCB58 = exports.validateBech32 = exports.decodeBech32 = exports.encodeBech32 = exports.verifyChecksum = void 0;
const errors_1 = require("./errors");
const bech32 = __importStar(require("bech32"));
const bs58_1 = __importDefault(require("bs58"));
const crypto_1 = require("./crypto");
const bytes_1 = require("./bytes");
const HexPrefix = '0x';
function concatChecksum(buffer) {
    const hashBuffer = (0, crypto_1.sha256)(buffer).copyOf(28, 32);
    return bytes_1.JuneoBuffer.concat([buffer, hashBuffer]);
}
function verifyChecksum(value) {
    if (value.length < 5) {
        return false;
    }
    const buffer = value.copyOf(0, value.length - 4);
    return value.toHex() === concatChecksum(buffer).toHex();
}
exports.verifyChecksum = verifyChecksum;
function encodeBech32(hrp, buffer) {
    return bech32.bech32.encode(hrp, bech32.bech32.toWords(buffer.getBytes()));
}
exports.encodeBech32 = encodeBech32;
function decodeBech32(value) {
    const split = value.split('-');
    const part = split.length > 1 ? split[1] : split[0];
    const startIndex = part.lastIndexOf('1');
    if (startIndex < 0) {
        throw new errors_1.DecodingError('bech32 format must include "1" separator');
    }
    const hrp = part.slice(0, startIndex);
    if (hrp.length < 1) {
        throw new errors_1.DecodingError('bech32 hrp missing');
    }
    return bytes_1.JuneoBuffer.fromBytes(Buffer.from(bech32.bech32.fromWords(bech32.bech32.decode(part).words)));
}
exports.decodeBech32 = decodeBech32;
function validateBech32(value, expectedHrp, expectedPrefix = []) {
    const parts = value.split('-');
    if (parts.length < 1) {
        return false;
    }
    if (!expectedPrefix.includes(parts[0])) {
        return false;
    }
    const bech32 = parts[1];
    try {
        decodeBech32(bech32);
    }
    catch (error) {
        return false;
    }
    if (expectedHrp === undefined) {
        return true;
    }
    const hrp = bech32.slice(0, bech32.lastIndexOf('1'));
    return hrp === expectedHrp;
}
exports.validateBech32 = validateBech32;
function encodeCB58(buffer) {
    return bs58_1.default.encode(concatChecksum(buffer).getBytes());
}
exports.encodeCB58 = encodeCB58;
function isBase58(value) {
    if (value === '') {
        return false;
    }
    return /^[A-HJ-NP-Za-km-z1-9]*$/.test(value);
}
exports.isBase58 = isBase58;
function decodeCB58(value) {
    if (!isBase58(value)) {
        throw new errors_1.DecodingError('value is not base58');
    }
    const buffer = bytes_1.JuneoBuffer.fromBytes(Buffer.from(bs58_1.default.decode(value)));
    if (!verifyChecksum(buffer)) {
        throw new errors_1.DecodingError('value checksum is not valid');
    }
    return buffer.copyOf(0, buffer.length - 4);
}
exports.decodeCB58 = decodeCB58;
function encodeCHex(buffer) {
    return `${HexPrefix}${concatChecksum(buffer).toHex()}`;
}
exports.encodeCHex = encodeCHex;
function isHex(value) {
    if (value === '') {
        return false;
    }
    const hex = hasHexPrefix(value) ? value.substring(2) : value;
    return /^[0-9A-Fa-f]*$/.test(hex);
}
exports.isHex = isHex;
function hasHexPrefix(value) {
    return value.startsWith(HexPrefix);
}
exports.hasHexPrefix = hasHexPrefix;
function decodeHex(value) {
    if (!isHex(value)) {
        throw new errors_1.DecodingError('value is not hexadecimal');
    }
    let hex = value;
    if (hasHexPrefix(hex)) {
        hex = hex.substring(2);
    }
    return bytes_1.JuneoBuffer.fromString(hex, 'hex');
}
exports.decodeHex = decodeHex;
function decodeCHex(value) {
    const buffer = decodeHex(value);
    if (!verifyChecksum(buffer)) {
        throw new errors_1.DecodingError('value checksum is not valid');
    }
    return buffer.copyOf(0, buffer.length - 4);
}
exports.decodeCHex = decodeCHex;
